import { useCollection } from "@/hooks/useCollection";
import type { CoreValue } from "@/lib/types";

export default function Values() {
  const { items } = useCollection<CoreValue>("core_values");

  if (items.length === 0) return null;

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-block text-sm font-semibold text-primary-600">
            Nos valeurs
          </span>
          <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Ce qui nous guide au quotidien
          </h2>
          <p className="mt-4 text-base text-foreground-600 leading-relaxed">
            Quatre valeurs fondamentales orientent chacune de nos décisions et
            de nos actions sur le terrain.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((value, index) => (
            <div
              key={value.title || index}
              className="bg-background-50 rounded-lg border border-background-200 p-6 md:p-7 transition-transform duration-300 hover:-translate-y-1"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className={`${value.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                {value.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}